import React from 'react';
import PropTypes from 'prop-types';
import _times from 'lodash/times';
import _map from 'lodash/map';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import renderIf from '@signal/utils/renderIf';
import { ListWrapper, MenuItemSkeleton, SubMenuItemSkeleton, BlankIcon } from './styles';
export var MenuListSkeleton = function MenuListSkeleton(props) {
  var _props$listItems = props.listItems,
      listItems = _props$listItems === void 0 ? [] : _props$listItems;

  var subMenuItems = function subMenuItems(num) {
    return _times(num, function (i) {
      return /*#__PURE__*/React.createElement(ListItem, {
        key: i
      }, /*#__PURE__*/React.createElement(ListItemText, {
        inset: true
      }, /*#__PURE__*/React.createElement(SubMenuItemSkeleton, null)));
    });
  };

  return /*#__PURE__*/React.createElement(ListWrapper, null, /*#__PURE__*/React.createElement(List, null, _map(listItems, function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i
    }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(BlankIcon, null)), /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(MenuItemSkeleton, null))), subMenuItems(item.subMenuItems), renderIf(item.divider, function () {
      return /*#__PURE__*/React.createElement(Divider, null);
    }));
  })));
};
MenuListSkeleton.propTypes = {
  listItems: PropTypes.arrayOf(PropTypes.shape({
    divider: PropTypes.bool,
    subMenuItems: PropTypes.number.isRequired
  })).isRequired
};
export default MenuListSkeleton;